import { render, staticRenderFns } from "./RelationshipSelect.vue?vue&type=template&id=5b075b80&"
import script from "./RelationshipSelect.vue?vue&type=script&lang=js&"
export * from "./RelationshipSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports